<template>
  <div
    :class="classes"
    class="trade-buy-sell-header p-10"
  >
    <div
      class="trade-buy-sell-header__title txt--weight-500 txt--12px txt--height-16px"
      :class="'txt--color-04' || `txt--${theme}`"
    >
      {{ title }}
      {{ mainTicker }}
    </div>
    <div
      v-if="logged"
      class="trade-buy-sell-header__balance txt--color-04 txt--12px txt--height-14px pt-4 pb-4 pl-6 pr-6"
      @click="$emit('balance-click')"
    >
      <span class="trade-buy-sell-header__wallet-icon mr-5">
        <img src="@/assets/icons/trade/piggy-bank.svg" alt="wallet icon">
        <!-- {{ $t('trade.buySell.available') }}: -->
      </span>
      <span class="trade-buy-sell-header__wallet-balance txt--weight-500">
        {{ balance }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { TRADE_TYPE } from '@/lib/constants'

export default {
  name: 'TradeBuySellHeader',
  components: {
  },
  props: {
    tradeType: {
      validator: v => ['buy', 'sell'].includes(v),
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    mainTicker: {
      type: String,
      default: '',
    },
    balance: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'grey',
    },
  },
  data () {
    return {
      TRADE_TYPE,
    }
  },
  computed: {
    ...mapState({
      logged: state => state.auth.loggedIn,
    }),
    classes () {
      return {
        'bg--transp-06': this.tradeType === 'buy',
        'bg--transp-05': this.tradeType === 'sell',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-buy-sell-header {
  $root: &;

  display: flex;
  justify-content: flex-end;
  overflow-x: auto;
  max-height: toRem(45px);

  @include bp(l) {
    justify-content: space-between;
  }

  // &--red {
  //     @include bp(l) {
  //         background: rgba(250, 63, 81, 0.1);
  //     }
  // }

  // &--green {
  //     @include bp(l) {
  //         background: rgba(73, 199, 116, 0.1);
  //     }
  // }

  &__balance {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  &__title {
    margin-right: auto;
    display: flex;
    align-items: center;
  }
}
// .pb-12--l {
//   @include bp(l) {
//     padding-bottom: toRem(12px);
//   }
// }
</style>
